import { render, staticRenderFns } from "./DisagreeContactWithChild.vue?vue&type=template&id=338d9465"
import script from "./DisagreeContactWithChild.vue?vue&type=script&lang=ts"
export * from "./DisagreeContactWithChild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports